const id_transHistory = {
    "": "Riwayat transaksi",
    title: {
        invoice_sales: 'tagihan penjualan',
        invoice_purch: 'tagihan pembelian',
        penawaran: 'penawaran',
        out: 'delivery order',
        in: 'barang masuk',
        so: 'sales order',
        po_sales: "purchase order masuk",
        po_purch: "purchase order masuk",
        request: "permintaan barang",
    },

    label: {
        no_penawaran: "Nomor Penawaran",
        no_data: "tidak ada data",
        no_so: "nomor sales order",
        no_po_sales: "nomor purchase order masuk",
        no_po_purch: "nomor purchase order keluar",
        no_in: "nomor referensi delivery order",
        no_out: "nomor referensi delivery order keluar",
        no_invoice_sales: 'nomor tagihan penjualan',
        no_invoice_purch: 'nomor tagihan pembelian',
        no_request: 'nomor permintaan barang',
    }
}

export default id_transHistory;